import { useEffect, useRef, useState } from 'react';
import { AgencyService } from '../../app/agency/service';
import { User } from '../../model/user/User';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../store/rootReducer';
import { ErrorToast } from '../../utils/toasters';

export const useAgencyCreators = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [count, setCount] = useState(0);
    const [filterParams, setFilterParams] = useState({
        page: 1,
        perPage: 12,
        displayName: '',
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const lastSearchRef = useRef<string>();
    const lastPageRef = useRef<number>();
    const { updateInfluencers } = useSelector((state: IAllStates) => state.agency);

    useEffect(() => {
        const isNewSearch = lastSearchRef.current !== filterParams.displayName;
        const isPageChange = !isNewSearch && lastPageRef.current !== filterParams.page;
        lastSearchRef.current = filterParams.displayName;
        lastPageRef.current = filterParams.page;

        if (isNewSearch) {
            setIsLoading(true);
        } else if (isPageChange) {
            setIsFetchingMore(true);
        }

        let isCurrent = true;
        AgencyService.getAgencyUsersHeader(filterParams)
            .then(response => {
                if (!isCurrent) return;
                setUsers(response.data);
                setTotalPages(Math.ceil(response.count / response.perPage));
                setCount(response.count);
            })
            .catch(error => ErrorToast(error))
            .finally(() => {
                if (!isCurrent) return;
                setIsLoading(false);
                setIsFetchingMore(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [JSON.stringify(filterParams), updateInfluencers]);

    return {
        users,
        setCount,
        count,
        totalPages,
        filterParams,
        setFilterParams,
        isLoading,
        isFetchingMore,
    };
};
